import React from 'react';
import { IStage as Stage } from '../../../../global';
import makeStyles from '@material-ui/core/styles/makeStyles';
import StageAmountEdit from '../Stages/StageAmountEdit';
import StageDateEdit from '../Stages/StageDateEdit';

const useStyles = makeStyles((theme: any) => ({
  stageEditFields: {
    display: 'flex',
    alignItems: 'center',
    marginTop: theme.spacing(2),
  },
  leftSide: { marginRight: theme.spacing(2) },
  rightSide: { marginLeft: theme.spacing(2) },
}));

interface Props {
  stage: Stage;
  handleStageUpdate: (...args) => void;
  addOrDeleteError: (...args) => void;
}

export default function MobileStageEdit({
  stage,
  handleStageUpdate,
  addOrDeleteError,
}: Props) {
  const classes = useStyles();
  const props = { stage, handleStageUpdate, addOrDeleteError };

  return (
    <div className={classes.stageEditFields}>
      <div className={classes.leftSide}>
        <StageAmountEdit {...props} />
      </div>
      <div className={classes.rightSide}>
        <StageDateEdit {...props} />
      </div>
    </div>
  );
}
